import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { ApiResponse } from 'mds-ui/app/shared/model/apiresponse';
import { Constants } from 'mds-ui/app/shared/pipes/constants';
import { HandleError, HttpErrorHandler } from 'mds-ui/app/shared/service/http-error-handler.service';
import { environment } from 'mds-ui/environments/environment';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do'; // debug
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { catchError } from 'rxjs/operators';
import 'rxjs/Rx'; // use this line if you want to be lazy, otherwise:
import { Observable } from 'rxjs/Rx';
import { UserSearchVO } from '../models/userSearchVO';
import { UserResponse, UserVO } from '../models/userVO.model';

@Injectable()
export class UserRoleProfileService {
    private handleError: HandleError;
    public userVO: UserVO = new UserVO();
    public userSearchVO: UserSearchVO = new UserSearchVO();
    public locationCode: number;
    public locationName: string;
    constructor(private _http: HttpClient, private httpErrorHandler: HttpErrorHandler) {
        this.handleError = httpErrorHandler.createHandleError('UserRoleProfileService');
    }
    private httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            "Cache-Control": "no-cache",
            Pragma: "no-cache"
        })
    };

    getUserInfoByApplicationId(applicationId: number): Observable<UserVO[]> {
        return this._http.get<UserVO[]>(
            environment.userInfoByApplicationIdUrl + applicationId, this.httpOptions)
            .pipe(
                catchError(this.handleError('getUserInfoByApplicationId', []))
            );
    }
    userSearch(user: UserSearchVO): Observable<UserVO[]> {
        return this._http.post<UserVO[]>(environment.postUserSearchURL, user, this.httpOptions).pipe(
            catchError(this.handleError('personSearch()', [])));
    }

    getUsersDetailsById(mailId: string, userName: string, appId: number): Observable<UserResponse> {
        return this._http.get<any>(
            environment.getUsersDetailsByIdURL + mailId + "?userName=" + userName + "&appId=" + appId, this.httpOptions)
            .pipe(
                catchError(this.handleError('getUsersDetailsById', []))
            );
    }

    getApplicationName(): string {
        return this.userVO.userApplicationVOList[0].name;
    }

    getApplicationId(): number {
        return this.userVO.userApplicationVOList[0].applicationId;
    }

    getUserEmailID(): string {
        return this.userVO.emailId;
    }

    getRoleName(): string {
        return this.userVO.roleName;
    }
    //check all permissions like disable,visible, Enable,create, delete the resource permissions
    isAccessible(resourceName: string, permission: string) {
        if (this.userVO != null && this.userVO.applicationProfilesVO != undefined) {
            let i = 0;
            for (i = 0; i < this.userVO.applicationProfilesVO.userResourceVOList.length; i++) {
                for (let j: number = 0; j < this.userVO.applicationProfilesVO.userResourceVOList[i].permissions.length; j++) {
                    if (this.userVO.applicationProfilesVO.userResourceVOList[i].name == resourceName) {
                        if (this.userVO.applicationProfilesVO.userResourceVOList[i].permissions[j].permissionName == permission) {
                            if (permission == Constants.PERMISSIONS_EDIT) {
                                return false;
                            } else {
                                return true;
                            }
                        }
                    }
                }
            }
            if (i == this.userVO.applicationProfilesVO.userResourceVOList.length) {
                if (permission == Constants.PERMISSIONS_EDIT) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    }
    //check permissions like display the resource permissions
    isDisplayable(resourceName: string, permission: string) {
        if (this.userVO != null && this.userVO.applicationProfilesVO != undefined) {
            let i = 0;
            for (i = 0; i < this.userVO.applicationProfilesVO.userResourceVOList.length; i++) {
                for (let j: number = 0; j < this.userVO.applicationProfilesVO.userResourceVOList[i].permissions.length; j++) {
                    if (this.userVO.applicationProfilesVO.userResourceVOList[i].name == resourceName) {
                        if (this.userVO.applicationProfilesVO.userResourceVOList[i].permissions[j].permissionName == permission) {
                            if (this.checkParent(this.userVO.applicationProfilesVO.userResourceVOList[i].parentId)) {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    }
                }
            }
            if (i == this.userVO.applicationProfilesVO.userResourceVOList.length) {
                return false;
            }
        }
    }
    //returns true if parent configured as read
    checkParent(parentId: number): boolean {
        let i = 0;
        for (i = 0; i < this.userVO.applicationProfilesVO.userResourceVOList.length; i++) {
            for (let j: number = 0; j < this.userVO.applicationProfilesVO.userResourceVOList[i].permissions.length; j++) {
                if (this.userVO.applicationProfilesVO.userResourceVOList[i].resourceId == parentId) {
                    if (this.userVO.applicationProfilesVO.userResourceVOList[i].permissions[j].permissionName == Constants.PERMISSIONS_READ) {
                        return true;
                    }
                }
            }
        }
        if (i == this.userVO.applicationProfilesVO.userResourceVOList.length) {
            return false;
        }
    }
    DeleteUserInfoById(id: number, applicationId: number, userName: string): Observable<ApiResponse> {
        return this._http.get<any>(
            environment.deleteUserInfoById + id + "?applicationId=" + applicationId + "&userName=" + userName, this.httpOptions)
            .pipe(
                catchError(this.handleError('DeleteUserInfoById', []))
            );

    }

}